module.exports = __webpack_public_path__ + "img/message.974ab609.png";